import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
    apiKey: "AIzaSyCRKgltud3tPSsHvSuNc1nFaxytLGebbaw",
    authDomain: "ws-digital-3abf0.firebaseapp.com",
    projectId: "ws-digital-3abf0",
    storageBucket: "ws-digital-3abf0.firebasestorage.app",
    messagingSenderId: "162723015906",
    appId: "1:162723015906:web:b3b08fbcd84fc1db6b82bb",
    measurementId: "G-W83J2LKSBW"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);
